function addToHistory(client,behaviour,params, store, callback) {
  let index = store.clients.findIndex((clientObj) => clientObj.clientID == client.Client);
  console.log("RegisterToHistory store got",behaviour);
  let historyObj = {};
  if(behaviour.FormData) {
    historyObj.Note = JSON.stringify({String: behaviour.FormData.callremarks,Link:null,Reasons:behaviour.FormData.Reasons,CallbackTime:behaviour.FormData.callbackTime});
    historyObj.SegmentJSON = JSON.stringify(behaviour.FormData);
  }
  historyObj.EventTemplate =params.EventTemplate;
  historyObj.Registrant = params.Registrant ;
  historyObj.EventLabel = params.EventLabel;
  historyObj.RootTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.ParentTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.GrantTransactionId = '_FF00321822120916460149925921541158_';
  historyObj.TransactionTemplate =  'ProcessDefaultTemplate-0064-0070';
  historyObj.TransactionTemplateID =  '_FFFFFFFFFFFFFF00001646014960614772_';
  historyObj.ORole = behaviour.Role
  historyObj.OState = behaviour.State;
  historyObj.OAction = behaviour.Action;
  historyObj.OResult = behaviour.Result;
  historyObj.OCycle = behaviour.Cycle;
  historyObj.CState = behaviour.NextState;
  historyObj.OStateQualifier =  behaviour.Role + ":" + behaviour.Action+'/'+behaviour.Result;
  historyObj.BeginTime = (new Date()) .toISOString();
  historyObj.EndTime = (new Date()).toISOString();

  if(index != -1) {
    let GrantPath = JSON.parse(store.clients[index].ClientContext);
    let currentContent = JSON.parse(store.clients[index].CurrentContext);
    console.log("Got Grant data:",GrantPath);
    console.log("Got Grant data:",GrantPath.GrantID);
    console.log("Got current context : ",currentContent);
    console.log("Got current context  attributionid:",currentContent.AttributionID);
    let params = {"ClientID":client.Client,"GrantID":GrantPath.GrantID,"Token":window.LivingScript_0070.guid.generateSync()};
    let registerVal;let that = this;
    historyObj.ClientId = client.Client;
    historyObj.GrantID = GrantPath.GrantID;
    historyObj.Path = "History/Add";
    historyObj.ToPE = GrantPath.GrantPE;
    historyObj.CredentialPE = currentContent.credentialPE;
    historyObj.GatewayPE = currentContent.GatewayPE;
    historyObj.AgentOfPE = currentContent.AgentOfPE;
    historyObj.AttributionId = currentContent.AttributionID;

    $.ajax({
      type:"POST",
      url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/register",
      dataType:"json",
      contentType: "application/json",
      data: JSON.stringify({ClientId:client.Client,GrantID:GrantPath.GrantID}),
      success: function(data) {
          console.log("Got HTTP Response Register");
          console.log(data);
          if(data && data.status == "Registration successful") {
              //that.addToHistory(params);
              $.ajax({
                type:"POST",
                url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/action",
                data: historyObj,
                dataType:"json",
                success: function(data) {
                    console.log("Got HTTP Response Add");
                    console.log(data);
                    if(callback) {
                      //let historyObj = Object.assign(window.botStore.history,data);
                      callback(null, data);
                    }
                  }
              });
          }
        }
    });
  } else {
    console.log("client does not exist");
  }
}

export {
  addToHistory
}
